export enum SnackbarType {
  Error = 'snackbar-error',
  Info = 'snackbar-info',
  Success = 'snackbar-success',
  Warn = 'snackbar-warn'
}

